module.exports = __webpack_public_path__ + "static/media/step-indicator-1.28b30081.svg";